import React, { Component } from "react";
import {
  estadoFirmaEspecialista,
  subirFirmaEspecialista,
  eliminarFirmaEspecialista,
  urlFirmaEspecialista,
} from "./api";

/**
 * Firma del especialista (imagen). Obligatoria solo al imprimir PDF.
 */
class FirmaEspecialistaInforme extends Component {
  constructor(props) {
    super(props);
    this.inputRef = React.createRef();
    this.state = {
      tieneFirma: false,
      previewUrl: "",
      subiendo: false,
      eliminando: false,
      msg: "",
    };
  }

  componentDidMount() {
    this.cargarEstado();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.cedulaEspecialista !== this.props.cedulaEspecialista) {
      this.cargarEstado();
    }
  }

  cargarEstado = () => {
    const { cedulaEspecialista } = this.props;
    if (!cedulaEspecialista) {
      this.setState({ tieneFirma: false, previewUrl: "" });
      return;
    }
    estadoFirmaEspecialista(cedulaEspecialista)
      .then((est) => {
        this.setState({
          tieneFirma: est.tiene,
          previewUrl: est.tiene ? urlFirmaEspecialista(est.ruta) : "",
          msg: "",
        });
        if (this.props.onCambio) {
          this.props.onCambio(est.tiene);
        }
      })
      .catch(() => {
        this.setState({ tieneFirma: false, previewUrl: "" });
      });
  };

  abrirSelector = () => {
    if (this.inputRef.current) {
      this.inputRef.current.click();
    }
  };

  onArchivo = (e) => {
    const file = e.target.files && e.target.files[0];
    e.target.value = "";
    if (!file) return;
    const { cedulaEspecialista } = this.props;
    if (!cedulaEspecialista) {
      this.setState({ msg: "No se identifico al especialista en sesion." });
      return;
    }
    if (!/^image\/(png|jpeg|jpg|gif)$/i.test(file.type)) {
      this.setState({ msg: "Use una imagen PNG, JPG o GIF." });
      return;
    }
    this.setState({ subiendo: true, msg: "" });
    subirFirmaEspecialista(cedulaEspecialista, file)
      .then((res) => {
        this.setState({ subiendo: false });
        if (res && res.variable1) {
          const ruta = res.variable3 || "";
          this.setState({
            tieneFirma: true,
            previewUrl: urlFirmaEspecialista(ruta),
            msg: res.variable2 || "Firma guardada.",
          });
          if (this.props.onCambio) {
            this.props.onCambio(true);
          }
          if (this.props.onSubidaOk) {
            this.props.onSubidaOk();
          }
        } else {
          this.setState({
            msg: (res && res.variable2) || "No se pudo guardar la firma.",
          });
        }
      })
      .catch(() => {
        this.setState({
          subiendo: false,
          msg: "Error al subir la firma. Verifique su conexion.",
        });
      });
  };

  eliminarFirma = () => {
    const { cedulaEspecialista } = this.props;
    if (!cedulaEspecialista) {
      this.setState({ msg: "No se identifico al especialista en sesion." });
      return;
    }
    if (
      !window.confirm(
        "¿Eliminar su firma registrada? No podra imprimir PDF hasta subir una firma nuevamente."
      )
    ) {
      return;
    }
    this.setState({ eliminando: true, msg: "" });
    eliminarFirmaEspecialista(cedulaEspecialista)
      .then((res) => {
        this.setState({ eliminando: false });
        if (res && res.variable1) {
          this.setState({
            tieneFirma: false,
            previewUrl: "",
            msg: res.variable2 || "Firma eliminada.",
          });
          if (this.props.onCambio) {
            this.props.onCambio(false);
          }
        } else {
          this.setState({
            msg: (res && res.variable2) || "No se pudo eliminar la firma.",
          });
        }
      })
      .catch(() => {
        this.setState({
          eliminando: false,
          msg: "Error al eliminar la firma. Verifique su conexion.",
        });
      });
  };

  render() {
    const { tieneFirma, previewUrl, subiendo, eliminando, msg } = this.state;
    const ocupado = subiendo || eliminando;
    return (
      <div className="ic-firmaEspecialista">
        <p className="ic-firmaEspecialista-titulo">
          <strong>Firma del especialista</strong> (requerida para imprimir PDF)
        </p>
        <p className="ic-hint">
          Suba una imagen de su firma (PNG o JPG). Sin firma no podra imprimir el informe.
        </p>
        {previewUrl && (
          <div className="ic-firmaEspecialista-preview">
            <img src={previewUrl} alt="Vista previa de firma" />
          </div>
        )}
        <input
          ref={this.inputRef}
          type="file"
          accept="image/png,image/jpeg,image/gif"
          className="ic-firmaEspecialista-input"
          onChange={this.onArchivo}
        />
        <div className="ic-firmaEspecialista-acciones">
          <button
            type="button"
            className="boton"
            onClick={this.abrirSelector}
            disabled={ocupado}
          >
            {subiendo
              ? "Guardando firma..."
              : tieneFirma
                ? "Cambiar firma"
                : "Subir firma"}
          </button>
          {tieneFirma && (
            <button
              type="button"
              className="boton ic-btn-danger"
              onClick={this.eliminarFirma}
              disabled={ocupado}
            >
              {eliminando ? "Eliminando..." : "Eliminar firma"}
            </button>
          )}
        </div>
        {tieneFirma && !ocupado && (
          <span className="ic-firmaEspecialista-ok">Firma registrada</span>
        )}
        {msg && <div className="ic-msg">{msg}</div>}
      </div>
    );
  }
}

export default FirmaEspecialistaInforme;
